export const GET_COLLECTIONID = "GET_COLLECTIONID";
export const RESET = "RESET";
export const INCREMENT = "INCREMENT";
